import * as React from 'react'
import { Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import type Employee from 'modules/employees/store/models/Employee'
import { usePlanningVersions } from 'modules/time_planning/store/collections/planningVersions'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'
import dayConfigurations from 'modules/work_schedules/store/collections/dayConfigurations'
import overlapPeriods from 'modules/work_schedules/store/collections/overlapPeriods'
import { useSchedules } from 'modules/work_schedules/store/collections/schedules'

interface BodyProps {
  employee: Employee
  planningVersion: PlanningVersion | null | undefined
}

const Body = ({ employee, planningVersion }: BodyProps) => {
  const planningVersions = usePlanningVersions()
  const schedules = useSchedules()
  const employeeId = employee.attributes.id

  const { loading } = useAsyncData(
    () =>
      Promise.all([
        planningVersions.fetch({ data: { employee_ids: [employeeId] } }),
        schedules.fetch(),
        overlapPeriods.fetch(),
        dayConfigurations.fetch(),
      ]),
    [employeeId]
  )

  if (loading) {
    return (
      <Box alignItems="center" width="full" padding="s32">
        <Spinner />
      </Box>
    )
  }

  return <Outlet context={{ planningVersion, employee }} />
}

export default observer(Body)
